import React, { useState } from "react";
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Table,
  NavDropdown,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { BiCategory } from "react-icons/bi";
import { BsUnlock } from "react-icons/bs";
import { IoSearch } from "react-icons/io5";

import Images from "../Images";
import { FaCaretDown, FaCaretUp } from "react-icons/fa6";
import { BsInfoCircleFill } from "react-icons/bs";
import ReactPaginate from "react-paginate";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";
import Filtermodal from "../Modal/Filtermodal";

import Config from "../config/config";
import { formatNumber } from "../Actions/commonFunction";

function Tablelisting({
  data,
  setSelSubCat,
  selSubCat,
  itemsPerPage,
  categoryList,
  setSelCat,
  selCat,
  setCurrentPage,
  currentPage,
  networklist,
  selNetwork,
  setSelNetwork,
  min,
  setMin,
  max,
  setMax,
  getCoinlist,
  searchtext,
  setSearchtext,
}) {
  const [filtersmodal, setFiltersmodal] = useState(false);
  const navigate = useNavigate();

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };
  const [showDropdown, setShowDropdown] = useState(false);
  const [showSubDropdown, setShowSubDropdown] = useState(false);
  const offset = currentPage * itemsPerPage;
  const currentItems = data.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(data.length / itemsPerPage); //* itemsPerPage;
  const handleClick = (symbol) => navigate(`/coindetail/${symbol}`);

  return (
    <>
      {filtersmodal && (
        <Filtermodal
          onDismiss={(data) => {
            setFiltersmodal(false);
            if (data) {
              getCoinlist();
            }
          }}
          networklist={networklist}
          selNetwork={selNetwork}
          setSelNetwork={(data) => setSelNetwork(data)}
          categoryList={categoryList}
          setSelCat={(data) => setSelCat(data)}
          selCat={selCat}
          min={min}
          setMin={(data) => setMin(data)}
          max={max}
          setMax={(data) => setMax(data)}
        />
      )}
      <div className="coin_table mt-4 py-3">
        <img src={Images.smallround} className="smallround" alt="round" />
        <div className="d-flex align-items-center flex-wrap gap_lists px-3 mb-4">
          <Dropdown>
            <Dropdown.Toggle variant="primary" className="categorydrop">
              <img
                src={Images.menus}
                className="menus me-2"
                alt="categoryimg"
              />{" "}
              Categories
            </Dropdown.Toggle>
            <Dropdown.Menu className="edaface_drop navdrop">
              {categoryList.map((item, index) =>
                item.subcategory?.length > 0 ? (
                  <NavDropdown
                    onClick={() => {
                      setSelSubCat({ id: item?._id, name: item?.name });
                    }}
                    title={
                      <>
                        {item.name}
                        <MdOutlineKeyboardArrowRight className="rightsvg" />
                      </>
                    }
                    key={index}
                    className="dropzz"
                    id={`dropdown-${index}`}
                  >
                    {item.subcategory.map((subItem, subIndex) => (
                      <NavDropdown.Item
                        onClick={() => {
                          setSelCat({ id: item?._id, name: item?.name });
                          setSelSubCat({ id: "all", name: "all" });
                        }}
                        key={subIndex}
                        className="d-flex align-items-center justify-content-between"
                      >
                        {subItem.name}
                      </NavDropdown.Item>
                    ))}
                  </NavDropdown>
                ) : (
                  <Dropdown.Item
                    onClick={() => {
                      setSelCat({ id: item?._id, name: item?.name });
                    }}
                    key={index}
                  >
                    {item.name}
                  </Dropdown.Item>
                )
              )}
            </Dropdown.Menu>
          </Dropdown>
          <button
            type="button"
            className="themebtn rounded-1 py-2 px-3"
            onClick={() => {
              setSelCat({ id: "all", name: "all" });
              setSelSubCat({ id: "all", name: "all" });
            }}
          >
            <BiCategory /> All
          </button>
          <p className="mb-0">
            <BsUnlock /> Coin Categories
          </p>
          {categoryList?.length > 0 &&
            categoryList.map((category) => (
              <p
                className="mb-0 cat"
                onClick={() =>
                  setSelCat({ id: category._id, name: category.name })
                }
              >
                <img
                  className="cat_logo me-1"
                  src={`${Config.Back_URL}/category/${category.logo}`}
                />
                {category.name}
              </p>
            ))}
          <div className="position-relative">
            <input
              type="text"
              onChange={(e) => setSearchtext(e.target.value)}
              value={searchtext}
              className="form-control search_input"
              placeholder="Name,Symbol, or Rank"
            />
            <div onClick={() => getCoinlist()} className="search_list">
              <IoSearch />
            </div>
          </div>

          <button
            className="themebtn rounded-1 py-2 px-2"
            onClick={() => setFiltersmodal(true)}
          >
            <BiCategory /> Filters
          </button>
        </div>

        <Table responsive className="fulllist text-center">
          <thead>
            <tr>
              <th>EdaFace Rank</th>
              <th>Name of Crypto</th>
              <th>Crypto Symbol</th>
              <th>Current Price</th>
              <th>24-hour Trade Volume</th>
              <th>
                Circulating Supply <BsInfoCircleFill className="infocircle" />
              </th>
              {/* <th>
                Market Capitalization <BsInfoCircleFill />  
              </th> */}
            </tr>
          </thead>
          <tbody>
            {currentItems.map((item, index) => (
              <tr
                key={index}
                onClick={() => handleClick(item.tokenId)}
                className="listing_coin"
              >
                <td>{offset + index + 1}</td>
                <td>
                  <span className="fw-500">{item.name}</span>{" "}
                  <span className="shortname">{item.symbol}</span>
                </td>
                <td>
                  <img src={item.logo} className="coin" alt="bnb" />
                </td>
                <td className="fw-500">${item.usdPrice}</td>
                <td
                  style={{
                    color:
                      Number(item?.percent_24h?.current) >
                      Number(item?.percent_24h?.last)
                        ? "#16C784"
                        : "#ff0000",
                  }}
                >
                  {Number(item?.percent_24h?.current) >
                  Number(item?.percent_24h?.last) ? (
                    <FaCaretUp />
                  ) : (
                    <FaCaretDown />
                  )}{" "}
                  {item.voluem_24h}
                </td>
                <td>{formatNumber(Number(item.circulate_supply))}</td>
                {/* <td>{item.market}</td> */}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <p className="notes mt-3">
        Note that the cryptocurrencies are ranked in the order of Market
        Capitalization
      </p>

      <ReactPaginate
        previousLabel={<MdOutlineKeyboardArrowLeft />}
        nextLabel={<MdOutlineKeyboardArrowRight />}
        breakLabel={"..."}
        pageCount={pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={3}
        onPageChange={setCurrentPage}
        containerClassName={"pagination"}
        activeClassName={"active"}
      />
    </>
  );
}

export default Tablelisting;
